// extracted by mini-css-extract-plugin
module.exports = {"section":"SpendingLock_section__1gBFQ","searchBar":"SpendingLock_searchBar__3Fsri","marginBottomXL":"SpendingLock_marginBottomXL__KpI0G"};